<template>
  <div class="emblem-page">
    <section>
      <p class="title">정체성</p>
      <p class="content">
        낮은 지리적 접근성은 전남드래곤즈FC에게 가장 강력한 무기입니다. 지리적 요새를 활용하여
        적군을 궤멸하였던 이순신 장군의 전략은 드래곤던전(광양축구전용구장)에서 여전히 유효하며
        호시탐탐 승리를 노리던 모든 경쟁자들의 계획과 의지는 이곳에서 무너지고 전남드래곤즈FC만이
        승리자의 자리로 올라섭니다.
      </p>
      <div class="logo-div modify">
        <img class="slogan" src="@/assets/img/club/slogan.png" alt="slogan">
        <div class="download-div">
          <button class="ai-btn" @click="downloadFile('emblem_identity.ai')">AI 다운로드</button>
          <button class="jpg-btn" @click="downloadFile('emblem_identity.jpg')">JPG 다운로드</button>
        </div>
      </div>
    </section>
    <section>
      <p class="title">워드마크</p>
      <p class="content pl">
        전남드래곤즈FC의 워드마크는 클럽의 정체성을 상징적/직관적으로 표현한 대표적인 시각
        언어로써 클럽의 시각적 정체성을 함축적으로 소통하기 위해 단독으로 사용 가능한 로고
        (Club & Brand identity)이며 특별히 클럽명을 문자적/직접적으로 전달하기에 용이하다.
      </p>
      <div class="logo-div modify">
        <img src="@/assets/img/club/word_mark.png" alt="word_mark">
        <div class="download-div">
          <button class="ai-btn" @click="downloadFile('emblem_wordmark.ai')">AI 다운로드</button>
          <button class="jpg-btn" @click="downloadFile('emblem_wordmark.jpg')">JPG 다운로드</button>
        </div>
      </div>
    </section>
    <section>
      <p class="title">핵심가치</p>
      <div class="scroll">
        <img class="core_value" src="@/assets/img/club/core_value.png" alt="core_value">
      </div>
      <div class="download-div">
        <a href="/file/emblem_corevalue.pdf" download="emblem_corevalue">
        </a>
        <button class="ai-btn" @click="downloadFile('emblem_corevalue.pdf')">PDF 다운로드</button>
      </div>
    </section>
  </div>
</template>

<script>
import {downloadFile} from '@/lib';

export default {
  name: 'Identity',
  data() {
    return {
      tabList: [],
    }
  },
  mounted () {
  },
  methods: {
    downloadFile

  }
}
</script>
